export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    // 品牌季度
    getQuarterUserList: function getQuarterUserList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/brand/getVip",
        method: "get",
        params: data
      });
    },
    // 品牌公寓
    getQuarterHouseList: function getQuarterHouseList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "admin/house/get",
        method: "get",
        params: data
      });
    },
    // 公司相关
    // 品牌季度公司信息分页查询
    findAllBqCompanyinfo: function findAllBqCompanyinfo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/bq/companyinfo/findAllBqCompanyinfo",
        method: "post",
        data: data
      });
    },
    // 导出
    exportBrandQuarterUser: function exportBrandQuarterUser() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/bq/user/exportBrandQuarterUser",
        method: "post",
        data: data
      });
    },
    // 保存或修改公司信息
    saveOrUpdateBqCompanyinfo: function saveOrUpdateBqCompanyinfo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/bq/companyinfo/saveOrUpdateBqCompanyinfo",
        method: "post",
        data: data
      });
    },
    // 删除公司信息
    deleteBqCompanyinfo: function deleteBqCompanyinfo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/bq/companyinfo/deleteBqCompanyinfo",
        method: "post",
        data: data
      });
    },
    // 查询季度用户
    findAllBrandQuarterUser: function findAllBrandQuarterUser() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/bq/user/findAllBrandQuarterUser",
        method: "post",
        data: data
      });
    },
    // 新增季度用户
    addBqOpenAccount: function addBqOpenAccount() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/bq/user/addOpenAccount",
        method: "post",
        data: data
      });
    },
    // 添加备注
    addBqRemarks: function addBqRemarks() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/bq/user/addRemarks",
        method: "post",
        data: data
      });
    },
    // 取消季度
    cancelBq: function cancelBq() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/bq/user/cancelBq",
        method: "post",
        data: data
      });
    },
    // 保存或者编辑订单
    saveOrUpdateBrandQuarterOrder: function saveOrUpdateBrandQuarterOrder() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/bq/order/saveOrUpdateBrandQuarterOrder",
        method: "post",
        data: data
      });
    },
    // 订单记录分页查询
    findAllBrandQuarter: function findAllBrandQuarter() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/bq/order/findAllBrandQuarter",
        method: "post",
        data: data
      });
    },
    // 检查停用细节
    checkStopAccount: function checkStopAccount() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/bq/order/checkStopAccount",
        method: "get",
        params: data
      });
    },
    // 检查转移细节
    checkTransferAccount: function checkTransferAccount() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/bq/order/checkTransferAccount",
        method: "get",
        params: data
      });
    },
    // 检查账号开通
    checkOpenAccount: function checkOpenAccount() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/bq/order/checkOpenAccount",
        method: "get",
        params: data
      });
    },
    // 保存转移信息
    saveTransferAccount: function saveTransferAccount() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/bq/order/saveTransferAccount",
        method: "post",
        data: data
      });
    },
    // 保存停用信息
    saveStopAccount: function saveStopAccount() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/bq/order/saveStopAccount",
        method: "post",
        data: data
      });
    },
    // 查询订单信息用于编辑
    findBrandQuarterOrderByPhone: function findBrandQuarterOrderByPhone() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/bq/order/findBrandQuarterOrderByPhone",
        method: "get",
        params: data
      });
    },
    // 查询待续费订单信息
    findBrandQuarterOrderByPhoneForRenewal: function findBrandQuarterOrderByPhoneForRenewal() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/bq/order/findBrandQuarterOrderByPhoneForRenewal",
        method: "get",
        params: data
      });
    },
    setQuarterUserAuth: function setQuarterUserAuth() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/user/quarter/auth/set",
        method: "post",
        data: data
      });
    },
    // 导出报表
    exportQuarterUserReportList: function exportQuarterUserReportList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/report/export",
        method: "get",
        params: data
      });
    },
    // 报表查询
    getQuarterUserReportList: function getQuarterUserReportList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/report/get",
        method: "get",
        params: data
      });
    },
    //设置季度等级城市
    setQuarterCityLevel: function setQuarterCityLevel() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/quarter/editCity",
        method: "post",
        data: data
      });
    },
    //设置季度等级城市
    getQuarterOpenCity: function getQuarterOpenCity() {
      return request({
        url: "/api/v3/admin/quarter/getOpenCity",
        method: "get"
      });
    }
  };
});